var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgILeftArrow = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -21.283)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    transform: "translate(0 21.283)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.731,25.37a.6.6,0,0,1-.178.426L3.066,29.263l3.49,3.509a.6.6,0,1,1-.852.847L1.79,29.685a.608.608,0,0,1-.175-.424h0a.6.6,0,0,1,.178-.425l3.913-3.891a.6.6,0,0,1,1.025.426Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.557,29.261a.6.6,0,0,1-.6.6H2.237a.6.6,0,0,1,0-1.2H13.956A.6.6,0,0,1,14.557,29.261Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgILeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i_left_arrow.bfdcf837.svg";
export { ForwardRef as ReactComponent };